import { type FC, useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';

import { updatePageGroup } from '@editor2/reducers/editor/editorSlice';
import { pageGroupEditorContainer } from '@editor2/containers/PageGroupPage/styles';
import { type PageGroup } from '@editor2/types/pageGroup';
import CodeMirrorHTML from '@editor2/components/CodeMirrorHTML';
import { useDebouncedDispatch } from '@editor2/hooks/useDebouncedDispatch';

interface Props {
	pageGroup: PageGroup;
	courseId: number;
}

const PageGroupEditorForm: FC<Props> = (props) => {
	const { pageGroup, courseId } = props;

	const debouncedDispatch = useDebouncedDispatch();

	const [pageGroupProperties, setPageGroupProperties] = useState({
		name: pageGroup.name,
		description: pageGroup.description
	});

	useEffect(() => {
		const { name, description } = pageGroup;
		setPageGroupProperties({ name, description });
	}, [pageGroup]);

	const handleChange = (value) => {
		setPageGroupProperties({ ...pageGroupProperties, ...value });
		debouncedDispatch(updatePageGroup({ pageGroupId: pageGroup.family_id, courseId, ...value }));
	};

	const handleDescriptionChange = (value: string) => handleChange({ description: value });

	return (
		<Form className={pageGroupEditorContainer}>
			<Form.Group>
				<Form.Control
					size="lg"
					className="pageGroupName"
					value={pageGroupProperties.name}
					onChange={(e) => handleChange({ name: e.target.value })}
				/>

				<Form.Group>
					<Form.Label>Description</Form.Label>
					<CodeMirrorHTML
						value={pageGroupProperties.description}
						onChange={handleDescriptionChange}
					/>
				</Form.Group>
			</Form.Group>
		</Form>
	);
};

export default PageGroupEditorForm;
